import { conversationDraftApi } from '@/store/api/conversation/email/conversation.draft.api';
import type { TypeAppDispatch } from '@/store/store';
import type { TypeConversationDraft, TypeConversationTemplate } from '@/types/conversation/types.conversation.email.draft';

const byUpdated = (a: TypeConversationDraft, b: TypeConversationDraft): number =>
    new Date(b.updatedAt).getTime() - new Date(a.updatedAt).getTime() || (a.id < b.id ? -1 : 1);

const byTitle = (a: TypeConversationTemplate, b: TypeConversationTemplate): number => a.title.localeCompare(b.title, 'it');

export const writeConversationDraft = (dispatch: TypeAppDispatch, draft: TypeConversationDraft) => {
    dispatch(conversationDraftApi.util.updateQueryData('listConversationDrafts', undefined, (list) => {
        const index = list.findIndex((item) => item.id === draft.id);
        if (index >= 0 && new Date(list[index].updatedAt).getTime() > new Date(draft.updatedAt).getTime()) return;
        if (index >= 0) list[index] = draft;
        else list.push(draft);
        list.sort(byUpdated);
    }));
};

export const dropConversationDraft = (dispatch: TypeAppDispatch, id: string) => {
    dispatch(conversationDraftApi.util.updateQueryData('listConversationDrafts', undefined, (list) => list.filter((item) => item.id !== id)));
};

export const writeConversationTemplate = (dispatch: TypeAppDispatch, template: TypeConversationTemplate) => {
    dispatch(conversationDraftApi.util.updateQueryData('listConversationTemplates', undefined, (list) => {
        const index = list.findIndex((item) => item.id === template.id);
        if (index >= 0) list[index] = template;
        else list.push(template);
        list.sort(byTitle);
    }));
};

export const dropConversationTemplate = (dispatch: TypeAppDispatch, id: string) => {
    dispatch(conversationDraftApi.util.updateQueryData('listConversationTemplates', undefined, (list) => list.filter((item) => item.id !== id)));
};
